export default __webpack_public_path__ + "9bf956551f4e4ec8990bccdc0806d7aa.svg";